import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();
// Gets the logged in user data from local session

export const getProductsApi = (params = { keyword_search: "" }) => {
  // Extract keyword_search from params object, or use params directly if it's a string
  const keywordSearch = typeof params === 'string' ? params : (params.keyword_search || "");
  console.log('getProductsApi called with params:', params);
  console.log('keywordSearch extracted:', keywordSearch);
  return api.create(url.GET_PRODUCTS, { params: { keyword_search: keywordSearch } });
};

export const addNewProduct = (product) =>
  api.create(url.CREATE_PRODUCT_NEW, product, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const updateProduct = (product) =>
  api.update(url.UPDATE_PRODUCT_NEW, product, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const deleteProduct = (productID) =>
  api.create(url.DELETE_PRODUCTS, {
    params: { product_ids: [productID] },
  });

export const getProductDetail = (productID) =>
  api.create(url.GET_PRODUCT_DETAIL, { params: { product_id: productID } });
export const exportProduct = (dateFrom = null, dateTo = null) => {
  const params = { keyword_search: "" };
  
  // Thêm tham số thời gian nếu có - đồng bộ với Swift API
  if (dateFrom && dateTo) {
    params.start_date = dateFrom;
    params.end_date = dateTo;
  }
  
  // Debug log để kiểm tra tham số
  console.log("📤 EXPORT PRODUCT API CALL:");
  console.log("   URL:", url.EXPORT_PRODUCT);
  console.log("   Parameters:", params);
  console.log("   Date From:", dateFrom);
  console.log("   Date To:", dateTo);
  console.log("   " + "-".repeat(50));
  
  return api.create(
    url.EXPORT_PRODUCT,
    { params },
    {
      headers: {
        "Content-Type": "",
      },
      responseType: "blob",
    }
  );
};
